<template>
  <!-- disable-resize-watcher: senza, Vuetify riapre il drawer da solo quando la finestra torna sopra
       il breakpoint mobile. Aperto/chiuso lo decide solo l'utente (chat.open). -->
  <v-navigation-drawer
    v-model="chat.open"
    location="right"
    :width="520"
    disable-resize-watcher
    class="ai-chat-drawer"
  >
    <AiChatBody :chat="chat" />
  </v-navigation-drawer>
</template>

<script setup>
import { watch } from 'vue'
import AiChatBody from './AiChatBody.vue'
import { useAdminChatStore } from '../stores/adminChat.js'

const chat = useAdminChatStore()

watch(() => chat.open, (isOpen) => {
  if (isOpen && chat.models.length === 0) chat.loadModels()
}, { immediate: true })
</script>

<style scoped>
/*
 * La Home ha un <v-app> annidato dentro quello di App.vue: il drawer finisce in un layout alto
 * quanto la pagina, non quanto lo schermo, e con una pagina lunga scende in fondo e scorre con
 * essa. Lo si ancora quindi alla finestra, sotto la barra di navigazione.
 */
.ai-chat-drawer {
  position: fixed !important;
  top: var(--v-layout-top, 48px) !important;
  bottom: 0 !important;
  height: auto !important;
  max-height: none !important;
  z-index: 1010;
}
</style>
